import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUser } from "~/Context/userContext";
import styled from "styled-components";

export const ReruleButtonWrapper = styled.section`
  background-color: #eaeaea;
  border-radius: 5px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px 0 #e6e6e6;
  a:hover {
    cursor: "pointer";
    color: "#000";
  }
  span {
    font-size: 12px;
    text-decoration: none;
    margin-left: 10px;
    margin-top: 8px;
    display: inline-block;
    vertical-align: text-top;
    user-select: none;
  }
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Rerule = ({ trackId }) => {
  const { state: userState } = useUser();
  if (userState.loggedin && userState.isChim && trackId)
    return (
      <ReruleButtonWrapper>
        <Link to={`/menu/step-2/rerule/${trackId}`} title="Click to re-rule this track... similar to a re-tweet">
          <FontAwesomeIcon icon={["fas", "retweet"]} />
          <span>Re-Rule</span>
        </Link>
      </ReruleButtonWrapper>
    );
  return null;
};

// Rerule.propTypes = {
//   trackId: PropTypes.number
// };

export default Rerule;
